module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = [], __append = __output.push.bind(__output);
  with (locals || {}) {
    ; __append("<tr class=\"view\">\n    <td style=\"width: 70%\">\n        <span class=\"gis-underline gl-pointer link\" view=\"")
    ; __append(escapeFn( view.id ))
    ; __append("\" title=\"Включить\" on-click=\"onUserViewLoadClick\">")
    ; __append(escapeFn( view.name ))
    ; __append("</span>\n    </td>\n    <td style=\"text-align: right\">\n        <span class=\"icon-16 icon-trash-o gl-pointer\" view=\"")
    ; __append(escapeFn( view.id ))
    ; __append("\" title=\"Удалить\" on-click=\"onUserViewRemoveClick\"></span>\n    </td>\n</tr>")
  }
  return __output.join("");

}